module.exports = __webpack_public_path__ + "img/poster.8dde8fe7.png";